module.exports = __webpack_public_path__ + "static/media/google-play.4a2a1c43.svg";